import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { CustomDirectivesModule } from '../shared/custom-directives/custom-directives.module';
import { DateTimeConvertorModule } from '../shared/date-time-convertor/date-time-convertor.module';
import { FileUploadModule } from '../shared/file-upload/file-upload.module';
import { StatusBannerModule } from '../shared/status-banner/status-banner.module';
import { OfferTypeService } from './offer-type.service';
import { OfferComponent } from './offer/offer.component';
import { ShipmentActionsService } from './shipment-actions.service';
import { ShipmentConfirmationDialogComponent } from './shipment-confirmation-dialog/shipment-confirmation-dialog.component';
import { ShipmentConfirmationInputDialogComponent } from './shipment-confirmation-input-dialog/shipment-confirmation-input-dialog.component';
import { ShipmentContactDetailsComponent } from './shipment-contact-details/shipment-contact-details.component';
import { ShipmentContactsComponent } from './shipment-contacts/shipment-contacts.component';
import { ShipmentDataModule } from './shipment-data/shipment-data.module';
import { ShipmentDocumentsService } from './shipment-data/shipment-documents.service';
import { ShipmentDetailsActionSheetComponent } from './shipment-details-action-sheet/shipment-details-action-sheet.component';
import { ShipmentDocumentComponent } from './shipment-document/shipment-document.component';
import { ShipmentDocumentsComponent } from './shipment-documents/shipment-documents.component';
import { ShipmentItemDetailsComponent } from './shipment-item-details/shipment-item-details.component';
import { ShipmentItemComponent } from './shipment-item/shipment-item.component';
import { ShipmentMessageComponent } from './shipment-message/shipment-message.component';
import { ShipmentUtilsService } from './shipment-utils.service';

@NgModule({
  declarations: [
    ShipmentContactsComponent,
    ShipmentContactDetailsComponent,
    ShipmentDocumentsComponent,
    ShipmentDocumentComponent,
    ShipmentItemComponent,
    ShipmentItemDetailsComponent,
    ShipmentConfirmationDialogComponent,
    ShipmentConfirmationInputDialogComponent,
    OfferComponent,
    ShipmentDetailsActionSheetComponent,
    ShipmentMessageComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatBottomSheetModule,
    ShipmentDataModule,
    FileUploadModule,
    StatusBannerModule,
    DateTimeConvertorModule,
    CustomDirectivesModule,
    MatCheckboxModule
  ],
  providers: [ShipmentActionsService, ShipmentDocumentsService, ShipmentUtilsService, OfferTypeService],
  exports: [
    ShipmentContactsComponent,
    ShipmentDocumentsComponent,
    ShipmentDocumentComponent,
    ShipmentItemComponent,
    ShipmentItemDetailsComponent
  ]
})
export class LoadsSharedModule { }

export { ShipmentContactsComponent } from './shipment-contacts/shipment-contacts.component';
export { ShipmentDocumentComponent } from './shipment-document/shipment-document.component';
export { ShipmentDocumentsComponent } from './shipment-documents/shipment-documents.component';
export { ShipmentItemComponent } from './shipment-item/shipment-item.component';

